import React from 'react';

import ShadeSVG from './assets/shade-loading.svg';

export const ShadeLoading = () => (
  <div data-testid="shade-loading">
    <img src={ShadeSVG} alt="" />
  </div>
);
